import { useEffect, useState } from 'react'

/**
 * Saniyede bir tazelenen "şimdi".
 *
 * Geri sayımlar sunucudan gelen `secondsToClose` ile değil, tarayıcı saatiyle
 * hesaplanıyor: sunucu değeri yalnız anlık görüntü anında doğru, aradaki her
 * saniyede geride kalır ve sayaç zıplar.
 */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs)
    return () => window.clearInterval(id)
  }, [intervalMs])

  return now
}
